// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Edit_wrapper__3jS18","title":"Edit_title__9mGWe"};